var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFlashSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "636296D7-62B3-4BC4-89D6-989128EB2D0C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-492.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flash-slash",
    transform: "translate(492.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6808605,2.22890626 L2.23085938,20.6889076 C1.93085937,20.9889076 1.93085937,21.4789078 2.23085938,21.7789078 C2.38085939,21.9189078 2.57085936,21.9989071 2.77085936,21.9989071 C2.97085936,21.9989071 3.16085932,21.9189076 3.31085932,21.7689075 L21.7708607,3.3089062 C22.0808607,3.00890619 22.0808607,2.52890627 21.7708607,2.22890626 C21.4708607,1.92890625 20.9808605,1.92890625 20.6808605,2.22890626 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8204994,9.18087435 L9.18050003,14.8208733 L9.18050003,13.2808733 L6.09049976,13.2808733 C4.69049978,13.2808733 4.30049956,12.4208734 5.23049957,11.3708735 L12.0004997,3.67087412 L12.8004999,2.76087397 C13.9104999,1.50087398 14.8204994,1.84087408 14.8204994,3.52087402 L14.8204994,9.18087435 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996872,20.3287497 L11.199687,21.2387495 C10.089687,22.4987495 9.1796875,22.1587492 9.1796875,20.4787493 L9.1796875,17.8187494 L16.2796879,10.71875 L17.909687,10.71875 C19.309687,10.71875 19.6996877,11.5787499 18.7696877,12.6287498 L11.9996872,20.3287497 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFlashSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-flash-slash.3dca0e45b6371499c1d30a40e383578f.svg";
export { ForwardRef as ReactComponent };